export default "__VITE_ASSET__STXCLX4w__"